import {HeaderMenuItem} from './header-menu-item';

export class HeaderAction implements HeaderMenuItem {
  public icon: string;
  public title: string;
  public url: string;

  constructor(title: string, url: string, icon: string) {
    this.title = title;
    this.url = url;
    this.icon = icon;
  }
}
